import { z } from 'zod'

export const GetUserSchema = z.object({
  avatar: z
    .object({
      url: z.string(),
    })
    .nullish(),
  created_at: z.coerce.date().nullish(),
  email: z.string().email(),
  id: z.number(),
  last_name: z.string().nullish(),
  locale: z.string(),
  name: z.string(),
  phone: z.string().nullish(),
  pid: z.string(),
  updated_at: z.coerce.date().nullish(),
})
